module.exports = __webpack_public_path__ + "img/soteria.4b40908c.svg";